import { useState, useEffect, useRef, useMemo } from "react";
import { FileApi } from '../../api/file/file-api';
import UserApi from '../../api/user//user-api-factory';
import { useMsal, } from '@azure/msal-react';
import { ImageCropper } from '../../components/images/image-cropper';
import _ from 'lodash';
import { Panel, PanelBody, PanelHeader } from "../../components/panel/panel";
import { UploadImageContainer, UploadAndDisplayImage2 } from "../files/upload-image";
import { arrayAny } from "../../utils/arrayUtils";

export const UserProfileImages = ({ aadPhotoDataUrl, systemProfile, graphProfile, setSystemProfile, setOriginalSystemProfile }) => {

    const imgRef = useRef(null);
    const aadRef = useRef(null);
    const profileRef = useRef(null);

    const { instance, inProgress, accounts } = useMsal();

    const fileApi = useMemo(() => new FileApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);
    const userApi = useMemo(() => new UserApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);

    const [rerender, setRerender] = useState(false);
    const [imgSrc, setImgSrc] = useState('');
    const [uploadProgress, setUploadProgress] = useState(null);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [imageCollection, setImageCollection] = useState([]);

    const uploadImage = async ref => {
        console.log('Upload button clicked');

        if (!uploadInProgress) {

            setUploadInProgress(true);
            setUploadProgress(0);

            const { previewCanvasRef, croppedImage } = ref.current.getState();

            const img = new Image();
            img.onload = () => {

                const outputCanvas = document.createElement('canvas');

                const maxDimension = 128;

                outputCanvas.width = maxDimension;
                outputCanvas.height = maxDimension;

                const outputCtx = outputCanvas.getContext('2d');
                // Assuming 'originalCanvas' contains your existing image
                outputCtx.drawImage(previewCanvasRef.current, 0, 0, maxDimension, maxDimension);

                outputCanvas.toBlob(blob => {

                    blob.name = "profile_thumbnail.jpg";
                    console.log("image to upload", blob);

                    const path = systemProfile.id;

                    fileApi.uploadFiles(systemProfile.companyName, path, [blob], data => {
                        const totalRemaining = _.sumBy(data, d => d.remainingBytes);
                        const progress = 1 - (totalRemaining / blob.size);
                        console.log(`Progress: ${progress * 100} %`);
                        setUploadProgress(progress);
                    })
                        .then(files => {
                            setUploadInProgress(false);
                            setUploadProgress(0);
                            console.log("File was successfully uploaded", files);
                            setSystemProfile(current => {
                                current.thumbnailProfileImage = files[0].path;
                                userApi.updateUser(current).then(data => {
                                    console.log("User updated", data);
                                    setSystemProfile(data);
                                    setOriginalSystemProfile(structuredClone(data));
                                })
                                    .catch(err => console.error("An error occurred updating User Profile.", err));

                                return current;
                            });
                        })
                        .catch(error => { console.log("Error occurred persisting file.", error); });
                }, 'image/jpeg', 0.7); // You can specify the image format here

            };

            img.src = URL.createObjectURL(croppedImage);
        }
    };

    useEffect(() => {

        const imgOnLoad = async (img, imgRef) => {
            imgRef.current = img;

            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            canvas.toBlob(blob => {
                const url = URL.createObjectURL(blob);
                setImgSrc(url);
            }, 'image/jpeg');
        };

        if (systemProfile && systemProfile.profileImageIncludingSasToken && systemProfile.profileImageIncludingSasToken.length > 0) {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = systemProfile.profileImageIncludingSasToken;
            img.onload = async () => await imgOnLoad(img, imgRef);
        }
    }, [systemProfile]);

    const uploadNewProfileImage = (collection, totalSize) => {

        const path = systemProfile.id;

        fileApi.uploadFiles(systemProfile.companyName, path, collection, data => {

            const totalRemaining = _.sumBy(data, d => d.remainingBytes);
            const progress = 1 - (totalRemaining / totalSize);
            console.log(`Progress: ${progress * 100} %`);
            setUploadProgress(progress);
        })
            .then(files => {
                setUploadInProgress(false);
                setUploadProgress(0);
                // TODO - Save profile?

                setSystemProfile(current => {
                    current.profileImage = files[0].path;
                    userApi.updateUser(current).then(data => {
                        console.log("User updated", data);
                        setSystemProfile(data);
                        setOriginalSystemProfile(structuredClone(data));
                    })
                        .catch(err => console.error("An error occurred updating User Profile.", err));

                    return current;
                });

            })
            .catch(error => { console.log("Error occurred persisting files.", error); })
            .finally(() => setUploadInProgress(false));

    };

    const handleAddNewImages = collection => {
        console.log("Add new images...", collection);

        const totalSize = _.sumBy(collection, f => f.size);

        if (!uploadInProgress) {
            setUploadInProgress(true);
            setUploadProgress(0);
            uploadNewProfileImage(collection, totalSize);
        }
    };

    return (
        <div className="tab-content panel p-3 rounded">
            <div className="tab-pane fade active show" id="default-tab-1">
                <div className='row'>

                    <div className="col-xl-4" key={"AADProfile"}>
                        <Panel
                            showReload={false}
                            showDelete={false}
                        >
                            <PanelHeader>Azure AD Profile Image</PanelHeader>
                            <PanelBody>
                                <>
                                    {!!aadPhotoDataUrl && !!systemProfile &&
                                        <div style={{ display: "flex" }}>
                                            <div className='mb-10px' style={{ maxHeight: '500px', maxWidth: '500px', margin: '0 auto' }}>
                                                <ImageCropper
                                                    src={aadPhotoDataUrl}
                                                    croppedFileName={"cropped.jpg"}
                                                    key={"ad-profile-picture"}
                                                    ref={aadRef}
                                                    onCropCompleted={() => setRerender(!rerender)}
                                                >
                                                    <p className="image-caption">
                                                        {systemProfile.displayName}<br />
                                                        {graphProfile.companyName}<br />
                                                        Azure AD Profile Image
                                                    </p>
                                                </ImageCropper>
                                            </div>

                                        </div>}
                                    <div>
                                        {!!aadRef && !!aadRef.current && !!aadRef.current.isCropped && !!aadRef.current.isCropped() && !uploadInProgress &&
                                            <button onClick={() => uploadImage(aadRef)} className='btn btn-primary'>Use This For Profile</button>
                                        }
                                        {uploadInProgress && uploadProgress === 0 && <div>Starting upload... please wait</div>}
                                        {uploadProgress > 0 && <div className="mt-2 progress-bar bg-indigo progress-bar-striped progress-bar-animated rounded-pill fs-10px fw-bold" style={{ width: uploadProgress * 100 + '%' }}>{`${(uploadProgress * 100).toFixed(2)}%`}</div>}
                                    </div>
                                </>
                            </PanelBody>
                        </Panel>
                    </div>

                    <div className="col-xl-4" key={"SystemProfile"}>
                        <Panel
                            showReload={false}
                            showDelete={false}
                        >
                            <PanelHeader>System Profile Image</PanelHeader>
                            <PanelBody>
                                <>
                                    {!!imgSrc && !!systemProfile &&
                                        <div style={{ display: "flex" }}>
                                            <div className='mb-10px' style={{ maxHeight: '500px', maxWidth: '500px', margin: '0 auto' }}>
                                                <ImageCropper
                                                    src={imgSrc}
                                                    croppedFileName={"cropped.jpg"}
                                                    key={"ad-profile-picture"}
                                                    ref={profileRef}
                                                    onCropCompleted={() => setRerender(!rerender)}
                                                >
                                                    <p className="image-caption">
                                                        {systemProfile.displayName}<br />
                                                        {graphProfile.companyName}<br />
                                                        System Profile Image
                                                    </p>
                                                </ImageCropper>
                                            </div>

                                        </div>}
                                    {!!profileRef && !!profileRef.current && !!profileRef.current.isCropped && !!profileRef.current.isCropped() && !uploadInProgress &&
                                        <button onClick={() => uploadImage(profileRef)} className='btn btn-primary'>Use This For Profile</button>
                                    }
                                    {uploadInProgress && uploadProgress === 0 && <div>Starting upload... please wait</div>}
                                    {uploadProgress > 0 && <div className="mt-2 progress-bar bg-indigo progress-bar-striped progress-bar-animated rounded-pill fs-10px fw-bold" style={{ width: uploadProgress * 100 + '%' }}>{`${(uploadProgress * 100).toFixed(2)}%`}</div>}
                                </>
                            </PanelBody>
                        </Panel>
                    </div>

                    <div className="col-xl-4" key={"UploadSystemImage"}>
                        <Panel
                            showReload={false}
                            showDelete={false}
                        >
                            <PanelHeader>Select A New Profile Image</PanelHeader>
                            <PanelBody>
                                <>
                                    <UploadImageContainer>
                                        <UploadAndDisplayImage2
                                            addImage={collection => { setImageCollection(collection) }}
                                            chooseFile={"Select a profile Image"}
                                            label={"New Profile Image"}
                                            maxFileCount={1}
                                            multiple={false}
                                        />
                                    </UploadImageContainer>
                                    {arrayAny(imageCollection) && <div className="mt-5px">
                                        <button onClick={() => handleAddNewImages(imageCollection)} className='btn btn-primary'>Use This For Profile</button>
                                    </div>}
                                    {uploadInProgress && uploadProgress === 0 && <div>Starting upload... please wait</div>}
                                    {uploadProgress > 0 && <div className="mt-2 progress-bar bg-indigo progress-bar-striped progress-bar-animated rounded-pill fs-10px fw-bold" style={{ width: uploadProgress * 100 + '%' }}>{`${(uploadProgress * 100).toFixed(2)}%`}</div>}
                                </>
                            </PanelBody>
                        </Panel>
                    </div>

                </div>
            </div>
        </div>
    );

};